import { PollCount } from '../../atoms';
import { PollBasicInfoProps } from './types';

export const PollBasicInfo = ({ pollCount }: PollBasicInfoProps) => (
    <p className="bg-white rounded-lg flex items-end py-2 px-4">
        <PollCount pollCount={pollCount}></PollCount>
        {/* <PollAvgPercentage pollAvgPercentage={70} ></PollAvgPercentage> */}
    </p>
);
